import UILayout from "components/layout/UILayout";
import Button, { ButtonLevel } from "components/ui/Button";
import Loading from "components/ui/Loading";
import { Heading } from "components/ui/Text";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getDashboard, usePostSeedReseedMutation } from "store/api/apiSlice";
import styled from "styled-components";

export const Wrapper = styled(UILayout)`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Admin = () => {
  const navigate = useNavigate();
  // HACK: Grab the dashboard data to ensure the user is logged in. 401 will redirect to users/sign_in.
  // Consider adding an AuthContainer in the future.
  const dashboard = getDashboard();
  const [postReseed, { isLoading, error, isSuccess: isSuccessPostReseed }] =
    usePostSeedReseedMutation();

  useEffect(() => {
    if (!isSuccessPostReseed) return;

    navigate("/users/sign_in");
  }, [isSuccessPostReseed]);

  if (dashboard.isLoading) return <Loading />;

  return (
    <Wrapper>
      <Heading.H1>Admin</Heading.H1>

      <Button
        onClick={() => postReseed()}
        disabled={isLoading}
        level={ButtonLevel.danger}
      >
        {isLoading ? "Reseeding..." : "Reseed Database"}
      </Button>

      {error && (
        <div style={{ color: "red", marginTop: "8px" }}>
          Failed to reseed database. Please try again.
        </div>
      )}
    </Wrapper>
  );
};

export default Admin;
